function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.25,
  stroke: "params(stroke)",
  strokeWidth: 1.5,
  fill: "transparent"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.293 9.293a1 1 0 010 1.414L11.05 14.95a1 1 0 11-1.414-1.414L12.172 11H5a1 1 0 110-2h7.171L9.636 6.464A1 1 0 1111.05 5.05l4.236 4.236.007.007z",
  fill: "params(fill) #00478C",
  stroke: "transparent"
});

function SvgSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSubmit;